import Bowser from 'bowser';
import { memo, forwardRef } from 'react';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

import { StyledScrollbar, StyledRootScrollbar } from './styles';

// ----------------------------------------------------------------------

// `color` is omitted because the MUI system `color` prop is incompatible with
// the plain string `color` prop of the underlying SimpleBar component.
type ScrollbarProps = Omit<BoxProps, 'color'>;

const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(({ children, sx, ...other }, ref) => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const mobile = browser.getPlatformType() === 'mobile';

  if (mobile) {
    return (
      <Box ref={ref} sx={{ overflow: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar
        scrollableNodeProps={{
          ref,
        }}
        clickOnTrack={false}
        sx={sx}
        {...other}
      >
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  );
});

export default memo(Scrollbar);
